var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#11bae4",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 359.09 359.09",
    xmlSpace: "preserve",
    stroke: "#11bae4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M359.09,139.004H243.6v11.568c-10.986-15.8-30.639-26.346-53.178-26.346c-24.593,0-45.768,12.551-55.965,30.803 l-0.003-16.141H99.09l-31.449,43.841l-37.809-43.84H0.203L0,219.971h28.024l0.269-39.114l36.966,42.295h6.866l34.134-42.295 l0.356,39.114h27.856l-0.003-15.893c10.206,18.238,31.372,30.785,55.954,30.785c34.562,0,62.477-24.727,62.477-55.323 c0-4.258-0.59-8.383-1.611-12.359h37.23l-52.646,52.903h117.301V193.57h-46.916L359.09,139.004z M190.422,203.774 c-15.245,0-27.524-10.879-27.524-24.378c0-13.5,12.281-24.374,27.524-24.374c15.256,0,27.533,10.874,27.533,24.374 C217.955,192.896,205.678,203.774,190.422,203.774z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoz);
export default __webpack_public_path__ + "static/media/moz.727dcde3978716286d23b0a1b12c551a.svg";
export { ForwardRef as ReactComponent };